import { LocalLookupService } from "@ofqual/portal-core/core/dataAccess";
import {
  API_HOST_PE,
  API_HOST_USERS,
  API_HOST_GUIDANCE,
  API_HOST_REFDATA,
  API_HOST_FOI,
  API_HOST_CWM,
  API_HOST_SARS,
  API_HOST_ORGS,
} from "../config";
import { PublicEnquiryService } from "./PublicEnquiryService";
import { UserService } from "./UserService";
import publicEnquiryStatuses from "./json/publicEnquiryStatuses.json";
import caseTypeSlaLookups from "./json/caseTypeSlaLookup.json";
import complaintTypes from "./json/complaintTypes.json";
import complaintNumber from "./json/centreNumberType.json";
import sources from "./json/sources.json";
import transferSource from "./json/transferSource.json";
import { cachingService } from "@ofqual/portal-core/core/dataAccess";
import { GuidanceService } from "./GuidanceService";
import { DashboardService } from "./DashboardService";
import { RefDataService, refDataEndpoints } from "./RefDataService";
import { FoiService } from "./FoiService";
import { CwmService } from "./CwmService";

// public enquiry -> sar stuff
import { SarsService } from "./SarsService";
import sarsTypeLookups from "./json/sarsTypeLookups.json";
import sarsContactMethodLookups from "./json/sarsContactMethodLookups.json";


import { SeriesYearsService } from "./SeriesYearService";
import { SeriesService } from "./SeriesService";
import { AwardingOrgSearchService } from "../services/AwardingOrgSearchService";
import { QualificationTypeService } from "./QualificationTypeService";
import { CountriesService } from "./CountriesService";

// import all ref data
export const customerTypeService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.customerType
);
export const directorateService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.directorate
);
export const focusEnquiryService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.focusOfEnquiry
);
export const categoryService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.category
);
export const themeEnquiryService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.themeOfEnquiry
);
export const learnerTypeService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.learnerType
);
export const contactTypeService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.contactMethod
);
export const cachedContactTypeService = cachingService(contactTypeService);
export const exceptionalCircumstanceService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.exceptionalCircumstance
);
export const foiTypeService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.foiType
);
export const subjectService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.subjects
);

export const publicEnquiryService = new PublicEnquiryService(API_HOST_PE);
export const dashboardService = new DashboardService(API_HOST_PE);
export const usersService = new UserService(API_HOST_USERS);
export const publicEnquiryStatusService = new LocalLookupService(
  publicEnquiryStatuses
);
export const caseTypeSlaService = new LocalLookupService(caseTypeSlaLookups);
export const qualTypeService = new QualificationTypeService(API_HOST_REFDATA);
export const seriesService = new SeriesService(API_HOST_REFDATA);
export const seriesYearService = new SeriesYearsService(API_HOST_REFDATA);
export const transferSourceService = new LocalLookupService(
  transferSource.sort((a,b) => {
    const order = a.order - b.order;
    if (order === 0)
      return a.label.localeCompare(b.label);
    return order;
  }));
export const aoService = new AwardingOrgSearchService(API_HOST_ORGS);
export const guidanceService = new GuidanceService(API_HOST_GUIDANCE);
export const foiService = new FoiService(API_HOST_FOI);
export const cwmService = new CwmService(API_HOST_CWM);

export const sourcesService = new LocalLookupService(sources);
export const complaintTypesService = new LocalLookupService(complaintTypes);
export const centreNumberService = new LocalLookupService(complaintNumber);

export const sarsService = new SarsService(API_HOST_SARS);
export const sarsTypeService = new LocalLookupService(sarsTypeLookups);
export const sarsContactTypeService = new LocalLookupService(sarsContactMethodLookups);

export const countriesService = new CountriesService(API_HOST_REFDATA);
